<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M10.8184 4.14974L9.19554 2.52686C8.40348 1.73483 8.00748 1.33881 7.55081 1.19043C7.14914 1.05992 6.71641 1.05992 6.31474 1.19043C5.85808 1.33881 5.46208 1.73483 4.67004 2.52686L3.59944 3.59745M0.599609 12.5973L0.631243 12.3758C0.743183 11.5923 0.799156 11.2005 0.926469 10.8347C1.03944 10.5101 1.19377 10.2014 1.38565 9.91636C1.60188 9.59503 1.88174 9.31516 2.44144 8.75549L10.2067 0.990134C10.7275 0.469434 11.5717 0.469434 12.0924 0.990134C12.6131 1.51083 12.6131 2.35505 12.0924 2.87575L4.18457 10.7836C3.6768 11.2914 3.42292 11.5452 3.13374 11.7471C2.87706 11.9263 2.60023 12.0748 2.30893 12.1894C1.98075 12.3186 1.62878 12.3896 0.924896 12.5316L0.599609 12.5973Z" 
      stroke="#262626" 
      stroke-opacity="0.88" 
      stroke-width="1.2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
</script>

<style lang="sass" scoped></style>